function issueDiscount (memberId) {
  window.open(`/members/${memberId}/member_offers/new_amount_off_consultation`);
  return true;
}
export default issueDiscount;
